<div class="h-dvh overflow-y-auto bg-gray-100">
  <div class="min-h-full flex items-center justify-center">
    <router-outlet></router-outlet>
  </div>
</div>
